<div class="account-body accountbg">
  <div class="container">
    <div class="row vh-100 d-flex justify-content-center">
      <div class="col-12 align-self-center">
        <div class="row">
          <div class="col-lg-5 mx-auto">
            <div class="card" style="border: none; border-radius: 12px; box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08); overflow: hidden;">
              <div class="card-body p-0 auth-header-box">
                <div class="text-center" style="padding: 1.25rem;">
                  <a href="index.html" class="logo logo-admin">
                    <img src="assets/images/loda-logo.png" height="40" alt="logo" class="auth-logo">
                  </a>
                </div>
              </div>
              <div class="card-body" style="padding: 1.75rem 2rem !important;">
                <div class="text-center">
                  <div class="tpo-loader-spin" style="margin-bottom: 1rem;">
                    <i-lucide name="loader-2" [size]="32" [strokeWidth]="2"
                      style="color: #3182CE;">
                    </i-lucide>
                  </div>
                  <h4 style="font-size: 1.125rem; font-weight: 600; color: #1A202C; margin: 0 0 0.5rem;">
                    Switching Company
                  </h4>
                  <p style="font-size: 0.875rem; color: #718096; margin: 0;">
                    Connecting to {{company?.companyName}}, please wait...
                  </p>
                </div>
              </div>
              <div class="card-body text-center" style="padding: 1rem 2rem !important; background-color: #F9FAFB; border-top: 1px solid #EDF2F7;">
                <span style="font-size: 0.75rem; color: #A0AEC0; letter-spacing: 0.02em;">Lodasoft &copy; {{currentYear}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
